import { AlertTriangle } from 'lucide-react';
import { useState } from 'react';
import { Button } from './button';
import { Input, Label } from './field';

export interface ConfirmState {
  readonly title: string;
  readonly body: string;
  readonly confirmLabel?: string;
  readonly tone?: 'danger' | 'warning';
  readonly onConfirm: () => void;
}

export function ConfirmDialog({ state, onClose }: { readonly state: ConfirmState | null; readonly onClose: () => void }) {
  const [confirmation, setConfirmation] = useState('');
  if (!state) return null;
  const confirmationWord = state.confirmLabel ?? 'Confirmar';
  const canConfirm = confirmation.trim() === confirmationWord;
  const close = () => {
    setConfirmation('');
    onClose();
  };
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-slate-950/35 p-4">
      <div className="w-full max-w-md rounded-md border border-[#d6ded0] bg-white shadow-xl">
        <div className="flex gap-3 border-b border-[#eef3ea] p-4">
          <div className={`grid h-10 w-10 shrink-0 place-items-center rounded-md ${state.tone === 'warning' ? 'bg-[#fff3d6] text-[#7a5a16]' : 'bg-[#fff8f8] text-[#8a4a3a]'}`}>
            <AlertTriangle className="h-5 w-5" aria-hidden="true" />
          </div>
          <div>
            <h2 className="text-base font-semibold text-slate-950">{state.title}</h2>
            <p className="mt-1 text-sm leading-6 text-[#5f6b58]">{state.body}</p>
            <div className="mt-3 grid gap-1.5">
              <Label htmlFor="confirmWord" className="text-xs">Escribe "{confirmationWord}" para continuar</Label>
              <Input id="confirmWord" value={confirmation} autoComplete="off" onChange={(event) => setConfirmation(event.target.value)} />
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-end gap-2 p-4">
          <Button type="button" variant="secondary" onClick={close}>Cancelar</Button>
          <Button type="button" disabled={!canConfirm} variant={state.tone === 'warning' ? 'primary' : 'danger'} onClick={() => { state.onConfirm(); close(); }}>
            {state.confirmLabel ?? 'Confirmar'}
          </Button>
        </div>
      </div>
    </div>
  );
}
